// action
import {
    EMERGENCY_DTRF,
    EMERGENCY_DTRF_FAIL,
    EMERGENCY_DTRF_SUCCESS,
    EMERGENCY_DTRF_RESET
} from '../action/saveEmergencyDtrfAction'
import { api_err_msg } from "../strings.json"

// initialState
const initialState = {
    apiState: "",
    data: {},
    message: ""
}

export default function (state = initialState, action) {
    switch (action.type) {
        case EMERGENCY_DTRF:
            return {
                ...state,
                apiState: "loading"
            }
        case EMERGENCY_DTRF_FAIL:
            return {
                ...state,
                apiState: "error",
                message: action.response && action.response.data && action.response.data.message || api_err_msg,
            }
        case EMERGENCY_DTRF_SUCCESS:
            return {
                ...state,
                apiState: "success",
                message: action.response.data.message,
            }
        case EMERGENCY_DTRF_RESET:
            return initialState
        default:
            return state
    }
}